export const loadCompanyFilterOptionsStart = (params) => {
  return { type: "LOAD_COMPANY_FILTER_OPTIONS_START", ...params };
};

export const loadCompanyFilterOptionsSuccess = (params) => {
  return { type: "LOAD_COMPANY_FILTER_OPTIONS_SUCCESS", ...params, };
};

export const loadCompanyFilterOptionsFailed = (params) => {
  return { type: "LOAD_COMPANY_FILTER_OPTIONS_FAILED", ...params };
};

export const loadCompanyFilterOptionsCancel = (params) => {
  return { type: "LOAD_COMPANY_FILTER_OPTIONS_CANCEL", ...params };
};

export const loadCompanyStart = (params) => {
  return { type: "LOAD_COMPANY_START", ...params };
};

export const loadCompanySuccess = (params) => {
  return { type: "LOAD_COMPANY_SUCCESS", ...params, };
};

export const loadCompanyFailed = (params) => {
  return { type: "LOAD_COMPANY_FAILED", ...params };
};

export const loadCompanyCancel = (params) => {
  return { type: "LOAD_COMPANY_CANCEL", ...params };
};

export const clearCompany = (params) => {
  return { type: "CLEAR_COMPANY", ...params };
};

export const setCompanyPageSize = (params) => {
  return { type: "SET_COMPANY_PAGE_SIZE", ...params };
};